import { object } from "yup";
import { coverageEffectiveDate, sevenDayEffectiveDate } from "@covertree/utils";

export interface ContinueQuoteForm {
  effectiveDate: string;
}

export const continueQuoteValidation = (
  email: string,
  defaultEffectiveDate?: string
) =>
  object({
    effectiveDate: defaultEffectiveDate
      ? sevenDayEffectiveDate("effective date", defaultEffectiveDate, email)
      : coverageEffectiveDate("Coverage effective date", false),
  });
